<template>
    <div> 
        <sui-message v-if="error" color="red">
            <sui-message-header>Error</sui-message-header>
            <p>{{ error }}</p>
        </sui-message>
    
        <sui-table celled>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell>When</sui-table-header-cell>
                    <sui-table-header-cell>Timestamp [ms]</sui-table-header-cell>
                    <sui-table-header-cell v-if="displayDeviceId">Device</sui-table-header-cell>
                    <sui-table-header-cell v-for="(col, colIndex) in colLabels" v-bind:key="colIndex">{{ col }}</sui-table-header-cell>
                    
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-for="(item, itemIndex) in items" v-bind:key="itemIndex">
                    <sui-table-cell>{{ item.timestamp | moment("from") }}</sui-table-cell>
                    <sui-table-cell>{{ item.timestamp }}</sui-table-cell>
                    <sui-table-cell v-if="displayDeviceId"><router-link :to="'/device/' + item.deviceId" class="nav-link">{{ item.deviceId }}</router-link></sui-table-cell>
                    <sui-table-cell v-for="(col, colIndex) in colLabels" v-bind:key="colIndex">{{ item[col] }}</sui-table-cell>
                    
                </sui-table-row>
            </sui-table-body>
    </sui-table>
  </div>
</template>

<script>
import DziService from '@/DziService'

export default {
  name: 'ListHistory',
  data () {
        return {
            items: [],
            error: null,
            cols: []
        }
    },  
props: {
    alias: {
      type: String,
    },
    deviceId:  {
      type: String,
    },
    displayDeviceId: {
        type: Boolean
    },
    start: {
        type: Number
    },
    end: {
        type: Number
    }
},
mounted () {
    this.loadData();
},
computed: {
    colLabels() {
        let cols = [];
        let skip = ['timestamp', 'deviceId'];
        
        
        for(let i in this.items)
        {
            Object.keys(this.items[i]).forEach(function(key) {
                
                if (skip.indexOf(key)==-1 && cols.indexOf(key)==-1) cols.push(key);
            })
        }
        
        return cols;
    },
    
},
methods: {
        timestampAgo() {
            return this.$moment()
        },
        async loadData() {
                
            var response = {'data': {'error': 'undefined field'}};       
                               
            if (this.deviceId)
            {
                
                response = await DziService.getDeviceHistory(this.deviceId, this.start, this.end);
            }
            else if (this.alias)
            {
                
                response = await DziService.getAliasHistory(this.alias, this.start, this.end);
            }
            console.log(response);
            
            if (typeof response.data.error !== 'undefined')
            {
                this.error = response.data.error;
            }
            else 
            {
                // event?
                this.items = response.data;
            }
        }
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
